<template>
	<div id="main">
		<div class="bai"></div>
		<div class="topimg">
			<div class="photo">
				<img v-if="!form.Photo" style="width: 100%;" src="../assets/暂无头像.jpg" alt="">
				<img v-if="form.Photo" style="width: 100%;" :src="form.RootPath+form.Photo" alt="">
			</div>
			<div class="personal-info">
				<div class="personal-name">
					<div class='name'>
						<span v-text='form.UserName||"未填写"'></span>
						<p v-if="form.Declaration" class="declaration" style="color: #666;">参赛宣言：<span style="margin-left: 10px;color:#333" v-text="form.Declaration||'未填写'"></span></p>
					</div>
					<button @click="editinfo()">编辑信息</button>
				</div>
				<div class="infolist">
					<p><span>机构名称：</span> {{form.Org||"未填写"}}</p>
					<p v-if='form.ProvinceName'><span>所在地区：</span> {{form.ProvinceName}}-{{form.CityName}}</p>
					<p v-if='!form.ProvinceName'><span>所在地区：</span> 未填写</p>
				</div>
				<div class="infolist">
					<p><span>专业擅长：</span> {{form.MajorIds||"未填写"}}</p>
					<p><span>从业时间：</span> {{form.WorkingStart}}年</p>
				</div>
				<div class="infolist">
					<div><span>持证类型：</span> {{form.CertIds||"无"}}</div>
				</div>
			</div>
			<div class="personal-btnbox" v-if='RegistType == 0'>
					<button class="personalbtn" @click="Individualparticipation()">个人参赛</button>
					<button class="teambtn" @click="Shutdown()">团队参赛</button>
			</div>

			<div class="personal-btnbox" v-if='RegistType == 2'>
				<div class="fusaibox">
					重要通知：所有参与复赛人员必须登录（网址：<a style="color:#1e1eff" target="_blank" href="http://dasai.bjjsyc.org.cn/">http://dasai.bjjsyc.org.cn/</a>）进行报名身份复核。
					<div class="fusaiimgbox">
						<img src="../assets/fusai.jpeg" alt="">
						<img class="fusai" src="../assets/fusai.jpeg" alt="">
					</div>
					<div class="fusaiimgbox">
						<img src="../assets/fusai2.jpeg" alt="">
						<img class="fusai2" src="../assets/fusai2.jpeg" alt="">	
					</div>
					<div class="fusaiimgbox">
						<img src="../assets/fusai3.jpeg" alt="">
						<img class="fusai3" src="../assets/fusai3.jpeg" alt="">	
					</div>
				</div>

				<div></div>
				<div>
					<button class="personalbtn" @click='video()'>线上学习</button>
					<button class="teambtn" @click='answer()'>复赛答题</button>
				</div>
			</div>
		</div>
		<div class="Introduction" v-if='RegistType == 0'>
			<h1 class="Introduction_title">个人简历</h1>
			<div style="height: 40px;"></div>
			<textarea readonly="readonly" class="Introduction-text" :value='form.Introduction||"未填写"'></textarea>
		</div>
		<div class="Introduction" v-if='RegistType == 2'>
			<div class="title-tab">
				<div :class="{active:activeteam == 1}" @click="switchFun(1)">个人简介</div>
				<div :class="{active:activeteam == 3}" @click="switchFun(3)">我的比赛</div>
			</div>
			<div style="height: 40px;"></div>
			<textarea  v-show="activeteam == 1" readonly="readonly" class="Introduction-text" :value='form.Introduction||"未填写"'></textarea>
			<div class="Introduction-text-3" v-show="activeteam == 3">
				<div style="height: 400px;width: 260px;">
				  <el-steps direction="vertical" :active="2" process-status='process'>
				  		<el-step @click.native="stepFun(index)" v-for="(item,index) in Process" :title="item.ProcessName+'('+item.ProcessTime+')'" :key='item.Id' :description='item.Descript'></el-step>
				  </el-steps>
				</div>
				<div class="game_information">
					<div class="text_top">
						<!-- <img v-show="Content == 0" style="width: 100%;margin-top: -20px;" src="../assets/process/报名.png" alt="">
						<img v-show="Content == 1" style="width: 100%;margin-top: -20px;" src="../assets/process/初赛.png" alt=""> -->
            <img style="width: 100%;margin-top: -20px;" :src="FullPhtoto" alt="">
					</div>
					<div class="text_bottom" v-show="Content == 1" >
						<div class="score" v-if="form.Score >= 0">比赛成绩：{{form.Score}}分！</div>
						<div class="score" v-if="form.Score < 0">您目前没有成绩，请前往答题</div>
						<div class="prompt">
							请等待其他参赛者完成试题，8月31日将通知您是否具备入围复赛的资格，届时将以短信形式通知各个参赛者，敬请留意！
						</div>
					</div>
				</div>
			</div>
		</div>
		<teamSign v-on:downfun='downfun' v-if='down'></teamSign>
		<IndividualEditor  v-on:Indguanbi='Indguanbi' v-if='isshow'></IndividualEditor>
	</div>
</template>

<script>

	import IndividualEditor from '@/components/common/IndividualEditor'
	import teamSign from '@/components/common/teamSign'
	export default{
		data(){
			return{
				down:0,
				isshow:0,
				form:{
					UserName:'',//名称
					Declaration:'',//宣言
					Introduction: '',//介绍
					WorkingStart:'',//从业时间
					ProvinceId:'',//省
					CityId:'',//市
					Cert:[],//持证
					Major:[],//擅长
				},
				activeteam:1,
        FullPhtoto:'',
				RegistType:0,
				Content:0,
				Process:[],
				ProcessIndex:0,
			}
		},
		created(){
			var competition_info = JSON.parse(localStorage.getItem('competition_info'))
			this.RegistType = competition_info.RegistType
			if(this.RegistType == 1){
				this.$router.push('/myteam')
			}
			this.getmember()
			this.getProcess()
		},
		methods:{
			getProcess(){
				this.axios.get("/api/CompetitionProcess/GetList?pageIndex=1&pageSize=200")
				.then(res=>{
					this.Process = res.data.data
					console.log(this.Process)
          this.FullPhtoto = res.data.data[0].FullPhtoto
					for(let x in this.Process){
						console.log(this.Process[x].IsCurrent)
						if(this.Process[x].IsCurrent){
							this.ProcessIndex = Number(x)+1
						}
					}
				})
			},
			stepFun(index){
				console.log(index)
				if(index < this.ProcessIndex){
					this.Content = index
          this.FullPhtoto = this.Process[index].FullPhtoto
				}
			},
			switchFun(activeteam){
				this.activeteam = activeteam
			},
			answer(){
				console.log(11111)
				this.$router.push('/answer')
			},
			video(){
				console.log(222)
				this.$router.push('/onlinevideo')
			},
			Individualparticipation(){
				console.log(!this.form.UserName)
				if(!this.form.UserName){
					this.$confirm('请先完善个人信息！', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
				}else{
					this.$confirm('个人参赛将不能参加团队比赛，请确认是否报名！', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						console.log(111)
						this.axios.post('/api/CompetitionRegist/PesonRegist')
						.then(res => {
								if(res.data.Success){
									this.$message({
									  message: '报名成功！',
									  type: 'success'
									});
									this.RegistType = 2
									var competition_info = JSON.parse(localStorage.getItem('competition_info'))
									competition_info.RegistType = 2
									localStorage.setItem("competition_info",JSON.stringify(competition_info))
									// window.history.go(0)
								}else{
									this.$message({
									  message: res.data.ErrorMsg,
									  type: 'error'
									});
								}
						})
						.catch(error => {
						  console.log(error)
						})
					}).catch(() => {

					});
				}

			},
			getmember(){
				this.axios.get('/api/member/GetMember')
				.then(res => {
						this.form = res.data.data
						if(res.data.data.RegistType == 1){
							this.$router.push('/myteam')
						}
				})
				.catch(error => {
				  console.log(error)
				})
			},
			Shutdown(){
				console.log(!this.form.UserName)
				if(!this.form.UserName){
					this.$confirm('请先完善个人信息！', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
				}else{
					this.down = 1
				}
			},
			editinfo(){
				this.isshow = 1
			},
			downfun:function(down){
				this.down = down
			},
			Indguanbi:function(Indguanbi){
				this.isshow  = Indguanbi
				this.getmember()
			}
		},
		components: {IndividualEditor,teamSign}
	}
</script>

<style scoped="scoped" lang="scss">
	#main{
		color: #333;
		background: url('../assets/2.jpg') #ecedee no-repeat;
		background-size: 100% 55%;
		overflow: hidden;
		position: relative;
		.bai{
			width: 900px;
			height: 300px;
			background: #fff;
			position: absolute;
			left: 0;right: 0;margin: auto;
			top: 140px;
		}
		.topimg{
			width: 900px;height: 380px;
			position: relative;
			margin: 90px auto 40px auto;
			background-image: url('../assets/top2.jpg');
			background-repeat: no-repeat;
			background-size:870px 280px;
			.photo{
				width: 165px;
				height: 215px;
				background: #c8c8d7;
				opacity: 0.5;
				position: absolute;
				top: 24px;
				left: 21px;
				display: flex;
				align-items: center;
			}
			.personal-info{
				width: 600px;
				height: 220px;
				position: absolute;
				top: 45px;right: 60px;
				.personal-name{
					display: flex;
					margin-bottom: 25px;
					margin-top: 20px;
					.name{
						flex: 1;
						font-size: 20px;
						font-weight: bold;
					}
					.declaration{
						font-size: 16px;
						margin-top: 10px;
						font-weight: initial;
					}
					button{
						background: #fff;
						border: #fff;
						border-radius: 30px;
						height: 28px;
						padding: 5px 20px;
						line-height: 15px;
						border: 1px solid #333;
					}
				}
				.infolist{
					display: flex;
					font-size: 16px;
					margin-top: 20px;
					span{
						color: #666;
					}
					p{
						width: 50%;
					}
				}
			}
			.personal-btnbox{
				position: absolute;
				width: 100%;
				height: 30px;
				bottom: 50px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.fusaibox{
					font-size:12px;margin-left:20px;display: flex;
					align-items: center;
					color: #e42128;
					.fusaiimgbox{
						width: 30px;
						margin-left:5px;
						position: relative;
						cursor: pointer; 
						img{width: 100%;}
						.fusai,.fusai2{
							position: absolute;
							width: 600px;
							top: 50px;left: -300px;
							z-index: 99999;
							display: none;
						}
						.fusai3{
							position: absolute;
							width: 400px;
							top: 60px;left: -300px;
							z-index: 99999;
							display: none;
						}
					}
					.fusaiimgbox:hover .fusai{
						display: block;
					}
					.fusaiimgbox:hover .fusai2{
						display: block;
					}
					.fusaiimgbox:hover .fusai3{
						display: block;
					}
				}
				
				
				button {
					padding: 5px 25px;
					color: #ab886b;
					border: 1px solid #ab886b;
					border-radius: 5px;
					margin-right: 20px;
				}
				.personalbtn {
					background: #ab886b;
					color: #fff;
					margin-right: 20px
				}
			}

		}
		.Introduction{
			width: 900px;
			height: 500px;
			overflow: scroll;
			background: #fff;
			margin: 0px auto;
			position: relative;
			.Introduction_title{
				text-align: center;background: #3e1976;
				line-height: 60px;
				height: 60px;
				color: #fff;
				position: absolute;
				top: 0;
				width: 100%;
				z-index: 1;
			}
			.title-tab{
				text-align: center;background: #3e1976;
				line-height: 60px;
				height: 60px;
				color: #fff;
				display: flex;
				justify-content: space-between;
				text-align: center;
				position: absolute;
				top: 0;
				width: 100%;
				background: #fff; z-index: 1;
				div{
					flex: 1;
					background: #fff;border: 1px solid #3e1976;
					color: #3e1976;
				}
				.active{
					background: #3e1976;
					color:#fff;
				}
			}
			.Introduction-text{
				padding: 30px 40px;
				background: #fff;
				border: none;
				box-sizing: border-box;
				line-height: 30px;font-size: 16px;
				width: 100%;outline:none;height: 445px;
			}
			.Introduction-text-3{
				padding: 30px 40px;background: #fff;box-sizing: border-box;font-size: 16px;display: flex;
				.game_information{
					flex:1;height: 400px;color: #333;
					padding: 0 20px;
					display: flex; flex-direction: column;
					overflow: scroll;
					.text_top{
						line-height: 24px;
						flex: 1;
					}
					.text_bottom{
						margin-top: -45px;
						.score{
							text-align: center;color: #e42128;font-size:20px;border-bottom: 1px solid #ededed;padding-bottom: 5px;background:#fff;
						}
						.prompt{
							font-size: 13px;
							padding: 10px 0;
						}
					}
				}
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/mycenter.vue